import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import {
	Form,
	Col,
	Row,
	FormGroup,
	FormControl,
	Container
} from 'react-bootstrap';

import Loader from '../../Common/Loader/Loader';
import ImageUploadComponent from '../../ImageUploadComponent/ImageUploadComponent';

import messages from '../../../locale/messages';
import validate from './validate';

import { api, homepageUploadDir } from '../../../config';
import submit from './submit';

import s from './DriverSettingsForm.css';

export class DriverSettingsForm extends Component {

	renderField = ({ input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder }) => {
		const { formatMessage } = this.props.intl
		return (
			<Form.Group>
				<Form.Label>{label}</Form.Label>
				<Form.Control {...input} placeholder={placeholder} type={type} className={cx(fieldClass, s.formControlInput)} />
				{touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
			</Form.Group>
		)
	}

	renderFormControlTextArea = ({ input, label, meta: { touched, error }, children, className }) => {
		const { formatMessage } = this.props.intl
		return (
			<div>
				<FormGroup className={s.space3}>
					<div>
						<label className={s.labelText} >{label}</label>
					</div>
					<div>
						<FormControl
							{...input}
							className={className}
							placeholder={label}
							as="textarea"
							rows="4"
						>
							{children}
						</FormControl>
						{touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
					</div>
				</FormGroup>
			</div>
		);
	}

	render() {
		const { handleSubmit, safetyGridImage4, safetyGridImage5, safetyGridImage6, loading, submitting, safetyGridImage5Loader, safetyGridImage4Loader, safetyGridImage6Loader } = this.props;
		const { formatMessage } = this.props.intl;
		return (
			<div className={cx(s.space5, s.spaceTop5)}>
				<Container fluid>
					<Row>
						<Col xl={10} lg={12} md={12} sm={12} xs={12} className={s.blackCenter}>
							<div className={s.blackCenterSection}>
								<Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
									<Col lg={12} md={12} sm={12} xs={12}>
										<h1 className={s.titleTextAdmin}>{formatMessage(messages.signupSectionSettings)}</h1>
									</Col>
									<Col lg={12} md={12} sm={12} xs={12}>
										<Row>
											<Col lg={4} md={12} sm={12} xs={12}>
												<Form.Group className={s.space3}>
													<div className={cx(s.profileImgSection, s.profileImgWidth)}>
														<ImageUploadComponent
															className={cx(s.btnSecondary, s.profileNoPadding)}
															subTextClass={s.subText}
															subText={formatMessage(messages.maximumUploadSizeLabel)}
															defaultMessage={formatMessage(messages.chooseFile)}
															loaderName={'safetyGridImage6Loader'}
															postUrl={api.apiEndpoint + '/uploadHomepageImage'}
															loader={safetyGridImage6Loader}
															fieldName={'safetyGridImage6'}
															formName={'DriverSettingsForm'}
															imageSrc={api.apiEndpoint + homepageUploadDir + 'medium_' + safetyGridImage6}
															label={formatMessage(messages.signupImage3)}
															inputContainer={'.dzInputContainerSafetyImage3'}
															inputContainerClass={'dzInputContainerSafetyImage3'}
															isDefaultImg={safetyGridImage6 ? false : true}
														/>
													</div>
												</Form.Group>
											</Col>
											<Col lg={4} md={12} sm={12} xs={12}>
												<Form.Group className={s.space3}>
													<div className={cx(s.profileImgSection, s.profileImgWidth)}>
														<ImageUploadComponent
															className={cx(s.btnSecondary, s.profileNoPadding)}
															subTextClass={s.subText}
															subText={formatMessage(messages.maximumUploadSizeLabel)}
															defaultMessage={formatMessage(messages.chooseFile)}
															loaderName={'safetyGridImage4Loader'}
															postUrl={api.apiEndpoint + '/uploadHomepageImage'}
															loader={safetyGridImage4Loader}
															fieldName={'safetyGridImage4'}
															formName={'DriverSettingsForm'}
															imageSrc={api.apiEndpoint + homepageUploadDir + 'medium_' + safetyGridImage4}
															label={formatMessage(messages.safetyImage1)}
															inputContainer={'.dzInputContainerSafetyImage1'}
															inputContainerClass={'dzInputContainerSafetyImage1'}
															isDefaultImg={safetyGridImage4 ? false : true}
														/>
													</div>
												</Form.Group>
											</Col>
											<Col lg={4} md={12} sm={12} xs={12}>
												<Form.Group className={s.space3}>
													<div className={cx(s.profileImgSection, s.profileImgWidth)}>
														<ImageUploadComponent
															className={cx(s.btnSecondary, s.profileNoPadding)}
															subTextClass={s.subText}
															subText={formatMessage(messages.maximumUploadSizeLabel)}
															defaultMessage={formatMessage(messages.chooseFile)}
															loaderName={'safetyGridImage5Loader'}
															postUrl={api.apiEndpoint + '/uploadHomepageImage'}
															loader={safetyGridImage5Loader}
															fieldName={'safetyGridImage5'}
															formName={'DriverSettingsForm'}
															imageSrc={api.apiEndpoint + homepageUploadDir + 'medium_' + safetyGridImage5}
															label={formatMessage(messages.safetyImage1)}
															inputContainer={'.dzInputContainerSafetyImage2'}
															inputContainerClass={'dzInputContainerSafetyImage2'}
															isDefaultImg={safetyGridImage5 ? false : true}
														/>
													</div>
												</Form.Group>
											</Col>
										</Row>
										<Row>
											<Col lg={12} md={12} sm={12} xs={12}>
												<Form.Group className={s.space3}>
													<div>
														<Field name="safetyGridTitle2" type="text" component={this.renderField} label={formatMessage(messages.driverAppTitle)} />
													</div>
												</Form.Group>
											</Col>
										</Row>

										<Row>
											<Col lg={12} md={12} sm={12} xs={12}>
												<Form.Group className={s.space3}>
													<div>
														<Field name="safetyGridContent2" type="text" component={this.renderFormControlTextArea} label={formatMessage(messages.driverAppContent)} />
													</div>
												</Form.Group>
											</Col>
										</Row>

										<Row>
											<Col lg={6} md={12} sm={12} xs={12}>
												<Form.Group className={s.space3}>
													<div>
														<Field name="safetyGridLink3" type="text" component={this.renderField} label={formatMessage(messages.playStoreLink)} />
													</div>
												</Form.Group>
											</Col>
											<Col lg={6} md={12} sm={12} xs={12}>
												<Form.Group className={s.space3}>
													<div>
														<Field name="safetyGridLink4" type="text" component={this.renderField} label={formatMessage(messages.appStoreLink)} />
													</div>
												</Form.Group>
											</Col>
										</Row>
										<Row>
											<Col lg={12} md={12} sm={12} xs={12} className={cx(s.textAlignRight, s.spaceTop1, 'textAlignLeftRTL')}>
												<Form.Group className={s.noMargin}>
													<div className={s.displayInlineBlock}>
														<Loader
															type={"button"}
															label={formatMessage(messages.submitButton)}
															show={loading}
															buttonType={'submit'}
															className={cx(s.button, s.btnPrimary)}
															disabled={submitting || loading}
															isSuffix={true}
														/>
													</div>
												</Form.Group>
											</Col>
										</Row>
									</Col>
								</Form>
							</div>
						</Col>
					</Row>
				</Container>
			</div>
		)
	}
}

DriverSettingsForm = reduxForm({
	form: 'DriverSettingsForm',
	onSubmit: submit,
	validate
})(DriverSettingsForm);

const selector = formValueSelector('DriverSettingsForm')
const mapState = (state) => ({
	safetyGridImage4: selector(state, 'safetyGridImage4'),
	safetyGridImage5: selector(state, 'safetyGridImage5'),
	safetyGridImage6: selector(state, 'safetyGridImage6'),
	loading: state.loader.DriverSettingsForm,
	safetyGridImage5Loader: state.loader.safetyGridImage5Loader,
	safetyGridImage4Loader: state.loader.safetyGridImage4Loader,
	safetyGridImage6Loader: state.loader.safetyGridImage6Loader
})

const mapDispatch = {

}

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(DriverSettingsForm)));